import { render, staticRenderFns } from "./RewardsList.vue?vue&type=template&id=901ff4b4&scoped=true&"
import script from "./RewardsList.vue?vue&type=script&lang=js&"
export * from "./RewardsList.vue?vue&type=script&lang=js&"
import style0 from "./RewardsList.vue?vue&type=style&index=0&id=901ff4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901ff4b4",
  null
  
)

export default component.exports